import { Injectable } from '@angular/core';
import { League } from "../model/league";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { collection, collectionData, doc, docData, Firestore, setDoc, updateDoc, deleteDoc, getDoc } from "@angular/fire/firestore";

@Injectable({
  providedIn: 'root'
})
export class LeaguesService {

  private leaguesCollection: any;

  constructor(
    private firestore: Firestore,
  ) {
    this.leaguesCollection = collection(this.firestore, 'leagues');
  }

  getLeagues(): Observable<League[]> {
    return (collectionData(this.leaguesCollection) as Observable<League[]>).pipe(
      map(leagues => leagues.filter(l => !l.archived))
    );
  }

  getAllLeagues(): Observable<League[]> {
    return collectionData(this.leaguesCollection) as Observable<League[]>;
  }

  getLeague(leagueId: string): Observable<League> {
    const documentReference = doc(this.firestore, `leagues/${leagueId}`);
    return docData(documentReference) as Observable<League>;
  }

  async addOrUpdateLeague(league: League): Promise<void> {
    const leagueDocRef = doc(this.firestore, 'leagues', league.id);
    const docSnap = await getDoc(leagueDocRef);

    // Firestore is not configured with ignoreUndefinedProperties, so undefined
    // values (e.g. an unset skinId) would make setDoc/updateDoc throw. Strip
    // them — same pattern as BroadcastsService.updateControl.
    const clean: any = {};
    Object.entries(league).forEach(([key, value]) => {
      if (value !== undefined) clean[key] = value;
    });

    if (docSnap.exists()) {
      return updateDoc(leagueDocRef, clean);
    } else {
      return setDoc(leagueDocRef, clean);
    }
  }

  deleteLeague(leagueId: string): Promise<void> {
    return deleteDoc(doc(this.firestore, 'leagues', leagueId));
  }

  archiveLeague(leagueId: string, archived: boolean): Promise<void> {
    const leagueDocRef = doc(this.firestore, 'leagues', leagueId);
    return updateDoc(leagueDocRef, { archived: archived });
  }
}
